define(['jquery'], function ($) {
    'use strict'

    return function () {
        // Activate first item for default
        $('.mega-menu__subitem--level1:first-child').addClass('active')

        // Change active sublist in hover
        $('.mega-menu__subitem--level1').hover(function() {
            const el = $(this)
            if($('.mega-menu__subitem--level1.active').length) {
                setTimeout(function() {
                    if (el.is(':hover')) {
                        el.addClass('active')
                        el.siblings().removeClass('active')
                    }
                }, 300)
            } else {
                el.addClass('active')
                el.siblings().removeClass('active')
            }
        })
    }
})
